<script lang="ts">
    import type {EditedProperty} from 'src/typings';
    import KpValueEditor from 'shared/value-editors/kp-value-editor/KpValueEditor.svelte';
    import {
        createValueEditorsLabelContext,
        setValueEditorLabelContext
    } from 'shared/value-editors/internal/label/value-editor-label-context';

    export let field: EditedProperty;
    export let model: unknown;
    export let isSingleField: boolean;

    const fieldLabelContext = createValueEditorsLabelContext(field.editor.editorId ?? field.fieldName, field.label);
    setValueEditorLabelContext(fieldLabelContext);
    const labelClickEvent$ = fieldLabelContext.clickEvent$;
    const labelConfig = fieldLabelContext.config;

    $: forAttribute = $labelConfig.disableForAttribute ? null : fieldLabelContext.editorId;

    function onLabelClick() {
        labelClickEvent$.next();
    }
</script>

<div class="facet-keys filter-field-{field.fieldName}">
    <!-- svelte-ignore a11y-click-events-have-key-events a11y-no-noninteractive-element-interactions label is clickable to emulate input focus on label click for non-native inputs -->
    <label id={fieldLabelContext.labelId}
           for={forAttribute}
           class="field-name"
           class:sr-only={isSingleField}
           on:click={onLabelClick}>
        {field.label}
    </label>

    <KpValueEditor {...field.editor}
                   editorId={field.editor.editorId ?? field.fieldName}
                   editorName={field.editor.editorName ?? field.fieldName}
                   bind:model
                   on:model-change/>
</div>